import { useMutation } from '@tanstack/react-query';
import { BaseContextType } from '@/types';
import { Services } from './services';

const useComments = () => useMutation((payload: BaseContextType) => Services.saveComments(payload));

export const Hooks = { useComments };
